import { render, staticRenderFns } from "./SidFlip.vue?vue&type=template&id=1876bd92"
import script from "./SidFlip.vue?vue&type=script&lang=js"
export * from "./SidFlip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports